<p-messages *ngIf="transaction.netSuiteId != null" severity="info">
    <ng-template pTemplate>
        <div *ngIf="!allowChangeEvenNetSuiteId">No se puede modificar una transacción que ha sido contabilizada.</div>
        <div *ngIf="allowChangeEvenNetSuiteId">Esta transacción ha sido contabilizada en NetSuite (ID: {{transaction.netSuiteId}}).<br><span class="text-danger text-bold">Tenga en cuenta que si realiza cambios, estos NO se trasladarán a NetSuite</span>.</div>
    </ng-template>
</p-messages>
<p-messages *ngIf="showMessageTransactionFromMigration" severity="info">
    <ng-template pTemplate>
        <div>No se puede acceder a esta transacción ya que es un transacción que viene de una migración.</div>
    </ng-template>
</p-messages>

<form *ngIf="transactionFormGroup" [formGroup]="transactionFormGroup">
    <p-card class="p-3 p-card-body-pb-0 " >
        <ng-template pTemplate="header">
            <div class="flex">
                <h3 class="m-0 mr-4"> Datos generales </h3> 
                <span *ngIf="transaction.isAdvancePayment" class="p-tag p-tag-info">ANTICIPO</span>
            </div>
        </ng-template>
        <div class="grid">
            <div class="col-2 input-field">
                <label for="name">Código *</label>
                <input pInputText formControlName="code" d-form-field-error *ngIf="transactionType.enableManualCode" />
                <input pInputText *ngIf="transaction.code && !transactionType.enableManualCode" value="{{transaction.code}}" disabled />
                <input pInputText *ngIf="!transactionType.enableManualCode && !transaction.id" [disabled]="true" placeholder="(Automático)" />
            </div>
            <div class="col-1 input-field">
                <label for="date">Fecha</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="date" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"></p-calendar>
            </div>
            <div class="col-2 input-field">
                <label for="name">Sociedad *</label>
                <p-dropdown formControlName="businessId" [options]="businesses" optionLabel="name" optionValue="id"
                    [filter]="true" filterBy="name" placeholder="Seleccione sociedad" appendTo="body" [required]="true"
                    d-form-field-error></p-dropdown>
            </div> 
            <div class="col input-field" *ngIf="transactionType.thirdPartyType != null">
                <label for="thirdPartyId" *ngIf="transactionType.thirdPartyType == 'Client'">Cliente *</label>
                <label for="thirdPartyId" *ngIf="transactionType.thirdPartyType == 'Company'">Compañía *</label>
                <label for="thirdPartyId" *ngIf="transactionType.thirdPartyType == 'Provider'">Proveedor *</label>
                <label for="thirdPartyId" *ngIf="transactionType.thirdPartyType == 'Worker'">Operario *</label>
                <label for="thirdPartyId" *ngIf="transactionType.thirdPartyType == 'Affected'">Implicado *</label>
                <p-dropdown formControlName="thirdPartyId" [options]="thirdParties" optionLabel="name" optionValue="id" [required]="true"
                    appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona un tercero" (onChange)="loadMoreTransactionInfo()"
                    (onFilter)="loadThirdParties($event)"
                    d-form-field-error emptyFilterMessage="No se encuentran datos" >
                    <ng-template pTemplate="selectedItem" let-item>
                        <app-deleted-label [resource]="item"></app-deleted-label>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <app-deleted-label [resource]="item"></app-deleted-label>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="col-2 input-field" *ngIf="transactionType.code == 'outgoing_invoice' || transactionType.code == 'company_outgoing_invoice'">
                <label for="name">Forma de pago</label>
                <p-dropdown formControlName="paymentMethodId" [options]="paymentsMethods" optionLabel="name" optionValue="id"
                    [filter]="true" filterBy="name" placeholder="Seleccione forma de pago" appendTo="body"
                    d-form-field-error></p-dropdown>
            </div> 
            <div class="col-1 input-field">
                <label for="date">Vencimiento</label>
                <p-calendar [firstDayOfWeek]="1" formControlName="paymentDuedate" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
                    [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error appendTo="body"></p-calendar>
            </div>
            <div class="col-2 input-field">
                <label for="transactionStateId">Estado</label>
                <p-dropdown formControlName="transactionStateId" [options]="transactionStates" optionLabel="name" optionValue="id"
                    appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona un estado"
                    (onChange)="onStateChange($event.value)" 
                    d-form-field-error></p-dropdown>
            </div>
            <!--<div class="col-2 input-field" *ngIf="transactionType.enableTransactionSerie">
                <label for="transactionSerieId">Serie</label>
                <p-dropdown formControlName="transactionSerieId" [options]="transactionSeries" optionLabel="name" optionValue="id"
                    appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona una serie"
                    d-form-field-error></p-dropdown>
            </div>-->
        </div>
        <div class="grid" *ngIf="transactionType.enableCase">
            <div class="col-5 input-field">
                <label for="caseId">Expediente</label>
                <input pInputText value="{{caseSelected?.displayName}}" disabled />
            </div>
            <div class="col-3 input-field">
                <label for="caseServiceId">Cita</label>
              
                <p-dropdown formControlName="caseServiceId" [options]="caseServices" optionLabel="name" optionValue="id"
                    appendTo="body" [filter]="true"  showClear filterBy="name" placeholder="Selecciona una cita"
                    d-form-field-error>
                    <ng-template pTemplate="selectedItem" let-caseService>
                        <div class="flex flex-column">
                            <div>{{caseService?.capability?.name}} - {{caseService?.date | date: 'dd/MM/yyyy'}}<br>
                                <small>{{caseService?.worker?.name}}</small>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-caseService pTemplate="item">
                        <div class="flex flex-column">
                            <div>
                                {{caseService?.capability?.name}} - {{caseService?.date | date: 'dd/MM/yyyy'}}
                                <small>{{caseService?.worker?.name}}</small>
                            </div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div> 
            <div class="col-4 input-field">
                <label for="caseId">Nº servicio</label>
                <p-dropdown formControlName="caseNotificationNumberId" [options]="caseNotificationNumbers" optionLabel="code" optionValue="id"
                    appendTo="body" [filter]="true" showClear placeholder="Selecciona un servicio"
                    d-form-field-error>
                    <!--<ng-template pTemplate="selectedItem" let-notificationNumber>
                        <div class="flex flex-column" *ngIf="transaction.caseNotificationNumberId">
                            <div>{{notificationNumber?.code}} - {{notificationNumber?.date | date: 'dd/MM/yyyy'}}</div>
                            <small>{{notificationNumber?.capabilityDescription}} - {{notificationNumber?.description}}</small>
                        </div>
                    </ng-template>-->
                    <ng-template let-notificationNumber pTemplate="item">
                        <div class="flex flex-column">
                            <div>{{notificationNumber?.code}} - {{notificationNumber?.date | date: 'dd/MM/yyyy'}}</div>
                            <small>{{notificationNumber?.capabilityDescription}} - {{notificationNumber?.description}}</small>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="col input-field" *ngIf="transactionType.code == 'purchase_order'">
                <label for="relatedInvoiceCode">Nº Factura proveedor</label>
                <input pInputText formControlName="relatedInvoiceCode"  d-form-field-error />
            </div>
        </div>
        <div class="grid"> 
            <div class="col-12 input-field">
                <label for="internalNotes">Notas internas</label>
                <textarea formControlName="internalNotes" pInputTextarea rows="3" maxlength="255" d-form-field-error></textarea>
                <small class="p-error" *ngIf="formValidationService.getValidationMessage(transactionFormGroup, 'internalNotes', { }) as internalNotesError">{{ internalNotesError }}</small>
            </div>
            <div class="col-12 input-field" *ngIf="transactionType.enableGeneralDescription">
                <label for="description">Observaciones</label>
                <textarea formControlName="description" pInputTextarea rows="5" d-form-field-error></textarea>
                <small class="p-error" *ngIf="formValidationService.getValidationMessage(transactionFormGroup, 'description', { }) as descriptionError">{{ descriptionError }}</small>
            </div>
            <div class="col-6 input-field" *ngIf="transactionType.enableEstimatedMaterialDays">
                <label for="estimatedMaterialDays">Previsión de días material</label>
                <input pInputText type="number" formControlName="estimatedMaterialDays" d-form-field-error />
            </div>            
            <div class="col-6 input-field" *ngIf="transactionType.enableEstimatedWorkHours">
                <label for="estimatedWorkHours">Previsión de horas de trabajo</label>
                <input pInputText type="number" formControlName="estimatedWorkHours" d-form-field-error />
            </div
            ><div class="col-12 input-field" *ngIf="transaction.transactionState?.enableStateNotes">
                <label for="transactionStateNotes">Descripción del estado </label>
                <textarea formControlName="transactionStateNotes" pInputTextarea rows="5" d-form-field-error></textarea>
            </div>
            <!--<div  *ngIf="transactionLogs.length > 0" class="col-12 input-field">
                <label>Eventos de la transacción</label>
                <div class="transactionLog">
                    <div class="col-12 input-field flex gap-3" *ngFor="let log of transactionLogs">
                        <div>
                            {{log.date | date: 'dd/MM/yyyy HH:mm'}}<br>
                            <small>
                                <b>
                                    <i class="pi pi-user" style="font-size: 8px"></i>
                                    {{log.createdByUser?.name}}
                                </b>                            
                            </small>
                        </div>
                        <div [innerHtml]="log.notes" style="white-space: pre-wrap;"></div>
                    </div>
                </div>
            </div>-->

        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button *ngIf="allowDelete && transaction.id && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" label="Eliminar"  icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button *ngIf="transaction.id" icon="pi pi-ellipsis-v" styleClass="p-button-secondary" (click)="transactionActionsMenu.toggle($event)"></p-button>
            <p-menu #transactionActionsMenu [popup]="true" [model]="transactionActionItems" appendTo="body"></p-menu>
            
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button *ngIf="transaction.id &&  transactionType.document_type" (click)="pdfTransaction(transactionType.code, transaction.id)" label="Generar" pTooltip="Generar el documento para poder imprimir" tooltipPosition="bottom" styleClass="p-button-secondary"><i class="pi pi-print"></i></p-button>
            <p-button *ngIf="transaction.id &&  transactionType.document_type && transactionType.enableFiles" (click)="pdfTransactionAndSave(transactionType.code, transaction.id)" label="Generar y agregar" pTooltip="Generar el documento para imprimir y agregarlo al expediente" tooltipPosition="bottom" styleClass="p-button-secondary"><i class="pi pi-file-plus"></i></p-button>
            <p-button *ngIf="transaction.id && selectedState?.code == 'pending' && type == 'company_outgoing_delivery_note'" label="Generar factura" icon="pi pi-play-circle" styleClass="p-button-secondary" (click)="generateInvoice()"></p-button>
            
            <p-button label="Guardar" *ngIf="type == 'company_outgoing_delivery_note' || (allowWrite && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId)))" icon="pi pi-check" styleClass="p-ml-2"
                (click)="checkAndsave()"></p-button>
        </div>
    </p-card>
    
    <p-card header="Líneas" *ngIf="transaction.id">     
        <div class="flex justify-content-end gap-2 mb-2" style="align-items: center;">     
            <p-checkbox *ngIf="transactionType.enableTax && showTaxCheckbox" (onChange)="toggleColumnTax($event)" [binary]="true" id="showTax"></p-checkbox>
            <label *ngIf="transactionType.enableTax && showTaxCheckbox" for="showTax">Mostrar impuestos</label>



            <p-button *ngIf="allowWrite && allowImportDocCreateLine && transactionType.enableFiles && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" label="Adjuntar documento y añadir línea" styleClass="ml-2" icon="pi pi-list-check"
                (click)="editTransactionLine(false, null, null, true)" />

            <p-button *ngIf="allowCopyTransactionLines && allowWrite && transactionFormGroup.get('caseId')?.value" label="Importar presupuestos" styleClass="ml-2" icon="pi pi-list-check"
                (click)="importTransactionLines()" />

            <!--<p-checkbox *ngIf="allowWrite && transactionType.thirdPartyType == 'Company'" formControlName="groupByCapability" [binary]="true" d-form-field-error></p-checkbox>
            <label *ngIf="allowWrite && transactionType.thirdPartyType == 'Company'" for="groupByCapability">Agrupar por especialidad</label>-->

            <p-button *ngIf="allowWrite && transactionFormGroup.get('caseId')?.value && transactionType.enableImportJobs &&  (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" label="Importar trabajos" icon="pi pi-briefcase"
                (click)="importJobs()" />
            <p-button *ngIf="allowWrite && allowImportExcel && transactionType.enableImportExcel && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" label="Importar Excel" icon="pi pi-file-excel"
                (click)="importExcel()" />
            <p-button *ngIf="allowWrite && transactionType.enableGroup &&  (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" label="Añadir grupo" icon="pi pi-server"
                (click)="editTransactionLine(true, null, null, false)" />
            <p-button *ngIf="allowWrite && allowCopyTransactionLines" label="Añadir plantilla de baremos" icon="pi pi-sliders-h"
                (click)="addRatesTemplate()" />
            <p-button *ngIf="allowWrite && transactionType.enableManualCreation && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" label="Añadir línea" icon="pi pi-plus"
                (click)="editTransactionLine(false, null, null, false)" />
            
        </div> 
        <p-table styleClass="m-1 mt-4" #grid [value]="transactionLines" [loading]="loadingTransactionLines"
                [totalRecords]="totalTransactionLines" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [scrollable]="true" scrollHeight="flex"
                (onRowReorder)="onRowReorder($event)"
               
                >
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width:3rem"></th>
                        <!--<th pSortableColumn="lineNumber"> <p-sortIcon field="lineNumber"></p-sortIcon></th> -->
                        <th *ngIf="this.type=='incoming_invoice'">Expediente</th>
                        <th>Especialidad</th>
                        <th *ngIf="transactionType.enableRate">Baremo</th>                        
                        <th>Descripción</th>                        
                        <th style="text-align: right;">Cantidad</th>                        
                        <th *ngIf="transactionType.enablePrice" style="text-align: right;">Precio unidad</th>  
                        <th *ngIf="transactionType.enableDiscount||transactionType.code=='purchase_order'" style="text-align: right;">Descuento</th>   
                        <th *ngIf="transactionType.enableDiscount" style="text-align: right;">Incremento</th>                                 
                        <th *ngIf="transactionType.enablePrice" style="text-align: right;">Subtotal</th>      
                        <th *ngIf="transactionType.enableTax&&showTax" style="text-align: right;">Impuestos</th>                        
                        <th *ngIf="transactionType.enablePrice && transactionType.enableTax && showTax" style="text-align: right;">Importe</th>                        
                        <th width="100"></th>
                    </tr>
                </ng-template> 
                <ng-template pTemplate="body" let-transactionLine let-i="rowIndex" let-columns="columns" let-index="rowIndex" let-editing="editing">
                    <tr *ngIf="transactionLine.isGroup && transactionType.enableGroup" (dblclick)="editTransactionLine(transactionLine.isGroup,  transactionLine, null)" [pReorderableRow]="i" [class.rowGroup]="transactionLine.isGroup">
                        <td>
                            <span class="pi pi-bars" pReorderableRowHandle></span>
                        </td>
                        <!--<td *ngIf="!showTaxCheckbox" [attr.colspan]="transactionType.thirdPartyType=='Company'?7:8" class="rowGroup"><b>{{transactionLine.description}}</b></td>
                        <td *ngIf="showTaxCheckbox" [attr.colspan]="transactionType.thirdPartyType=='Company'?(showTax?7:7):(showTax?6:6)" class="rowGroup"><b>{{transactionLine.description}}</b></td>-->
                        <td [attr.colspan]="transactionType.enableRate?3:2" >{{transactionLine.description}}</td>
                        <td *ngIf="transactionType.enablePrice"></td>  
                        <td *ngIf="transactionType.enableDiscount||transactionType.code=='purchase_order'"></td>   
                        <td *ngIf="transactionType.enableDiscount" ></td>                                 
                        <td *ngIf="transactionType.enablePrice"></td>      
                         <td style="text-align: right;">{{getTotalFromGroup(transactionLine).subtotal | currency: 'EUR'}}</td>
                        <td *ngIf="showTax"></td>
                        <td *ngIf="showTax" style="text-align: right;">{{getTotalFromGroup(transactionLine).total | currency: 'EUR'}}</td> 
                        <td>
                            <div class="flex gap-2 justify-content-end" [class.rowGroup]="transactionLine.isGroup">
                                <p-button *ngIf="allowDelete && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" (click)="deleteLine(transactionLine)" [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" (click)="editTransactionLine(transactionLine.isGroup, transactionLine, null)" [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="!transactionLine.isGroup" (dblclick)="openLineFromRow($event, transactionLine.isGroup, transactionLine)"
                        [pReorderableRow]="i">
                        <td>
                            <span class="pi pi-bars" pReorderableRowHandle></span>
                        </td>
                        <td *ngIf="this.type=='incoming_invoice'">
                            <a [routerLink]="['/cases', transactionLine.caseService?.case?.id]" target="_blank">{{transactionLine.caseService?.case?.caseNumber}}</a><br>
                        </td>
                        <td>
                            <span *ngIf="transactionLine.rateLine">{{transactionLine.rateLine?.capability?.name}}</span>
                            <span *ngIf="!transactionLine.rateLine">{{transactionLine.capability?.name}}</span>
                        </td>
                        <td *ngIf="transactionType.enableRate" [pEditableColumn]="transactionLine.rateLineId" pEditableColumnField="rateLineId"  (click)="onCellOpen(transactionLine)" [pEditableColumnDisabled]="!(allowWrite && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId)))">
                            
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-dropdown [(ngModel)]="transactionLine.rateLineId" 

                                        [ngModelOptions]="{standalone: true}" 
                                        [options]="rateLines" optionValue="id" optionLabel="displayName"
                                        appendTo="body" placeholder="Selecciona un código" (onChange)="onRateLineChange($event,transactionLine)"
                                        showClear [filter]="true" d-form-field-error>
                                        <ng-template let-rateLine pTemplate="item">
                                            <div class="flex flex-column">
                                                <div style="white-space: normal;max-width: 700px;">{{ rateLine.displayName }}</div>
                                                <small style="font-size: 8px;">{{ getRate(rateLine.rateId)?.name }}</small>
                                            </div>
                                        </ng-template>
                                    </p-dropdown>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{transactionLine.rateLineCode}} {{transactionLine.rateLineDescription}}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td [pEditableColumn]="transactionLine.description" pEditableColumnField="description" [pEditableColumnDisabled]="!(allowWrite && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId)))">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <textarea
                                        pInputTextarea rows="4" [autoResize]="true"
                                        class="line-description-editor"
                                        [(ngModel)]="transactionLine.description"
                                        [ngModelOptions]="{standalone: true}"
                                        (keydown.enter)="$event.preventDefault(); onLineEditComplete(transactionLine)"
                                        (keydown.control.enter)="insertLineBreak($event, transactionLine)"
                                        (blur)="onLineEditComplete(transactionLine)"
                                        ></textarea>
                                    <small class="line-description-hint">Pulsa <b>Ctrl+Enter</b> para salto de línea</small>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span [innerText]="transactionLine.description"></span>
                                    <p-button *ngIf="transactionLine.description" pTooltip="Copiar descripción" [text]="true" styleClass="btn-copiar-desc" (click)="copyText(transactionLine.description);  $event.stopPropagation()" ><i class="pi pi-copy"></i></p-button>
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td [pEditableColumn]="transactionLine.quantity" pEditableColumnField="quantity" [pEditableColumnDisabled]="!(allowWrite && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId)))" style="text-align: right;">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input
                                        pInputText type="number"
                                        [(ngModel)]="transactionLine.quantity"
                                        [ngModelOptions]="{standalone: true}" 
                                        (keydown.enter)="onLineEditComplete(transactionLine)"
                                        (blur)="onLineEditComplete(transactionLine)"
                                        />
                                </ng-template>
                                <ng-template pTemplate="output">
                                     {{transactionLine.quantity}}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="transactionType.enablePrice" style="text-align: right;" [pEditableColumn]="transactionLine.price" pEditableColumnField="price" [pEditableColumnDisabled]="!(allowWrite && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId)) && (!transactionLine.rateLineId || transactionLine.rateLine?.freePrice))">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input
                                        pInputText type="number"
                                        [(ngModel)]="transactionLine.price"
                                        [ngModelOptions]="{standalone: true}"
                                        (keydown.enter)="onLineEditComplete(transactionLine)"
                                        (blur)="onLineEditComplete(transactionLine)"/>
                                </ng-template>
                                <ng-template pTemplate="output">
                                     {{transaction.isReturn?'-':''}}{{transactionLine.price | currency: 'EUR' }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="transactionType.enableDiscount" style="text-align: right;" [pEditableColumn]="transactionLine.discountPercent" pEditableColumnField="discountPercent" [pEditableColumnDisabled]="!(allowWrite && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId)))">                            
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input
                                        pInputText type="number"
                                        [(ngModel)]="transactionLine.discountPercent"
                                        [ngModelOptions]="{standalone: true}" 
                                        (keydown.enter)="onLineEditComplete(transactionLine)"
                                        (blur)="onLineEditComplete(transactionLine)"/>
                                </ng-template>
                                <ng-template pTemplate="output">
                                     {{'('+(transactionLine.discountPercent!=null?transactionLine.discountPercent:0)+'%) '}}{{transactionLine.discountAmount | currency: 'EUR' }}
                                </ng-template>
                            </p-cellEditor>
                        </td>                        
                        <td *ngIf="transactionType.code=='purchase_order'" style="text-align: right;" [pEditableColumn]="transactionLine.discountAmount" pEditableColumnField="discountAmount" [pEditableColumnDisabled]="!(allowWrite && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId)))">                            
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input
                                        pInputText type="number"
                                        [(ngModel)]="transactionLine.discountAmount"
                                        [ngModelOptions]="{standalone: true}" 
                                        (keydown.enter)="onLineEditComplete(transactionLine)"
                                        (blur)="onLineEditComplete(transactionLine)"/>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{transactionLine.discountAmount | currency: 'EUR' }}
                                </ng-template>
                            </p-cellEditor>
                        </td> 
                        <td *ngIf="transactionType.enableDiscount" style="text-align: right;" [pEditableColumn]="transactionLine.incrementPercent" pEditableColumnField="incrementPercent" [pEditableColumnDisabled]="!(allowWrite && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId)))">
                            
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input
                                        pInputText type="number"
                                        [(ngModel)]="transactionLine.incrementPercent"
                                        [ngModelOptions]="{standalone: true}" 
                                        (keydown.enter)="onLineEditComplete(transactionLine)"
                                        (blur)="onLineEditComplete(transactionLine)"/>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{'('+(transactionLine.incrementPercent!=null?transactionLine.incrementPercent:0)+'%) '}}{{transactionLine.incrementAmount | currency: 'EUR' }}
                                </ng-template>
                            </p-cellEditor>
                        </td>                     
                                                  
                        <td *ngIf="transactionType.enablePrice" style="text-align: right;" >
                            
                                    {{transaction.isReturn?'-':''}}{{(transactionLine.subtotal) | currency: 'EUR' }}
                        </td>
                        <td *ngIf="transactionType.enableTax && showTax" style="text-align: right;">{{transaction.isReturn?'-':''}}    {{'('+(transactionLine.taxPercent!=null?transactionLine.taxPercent:0)+'%) '}}{{transactionLine.taxAmount | currency: 'EUR' }}</td>
                        <td *ngIf="transactionType.enablePrice && transactionType.enableTax && showTax" style="text-align: right;">{{transaction.isReturn?'-':''}}{{(transactionLine.subtotal + transactionLine.taxAmount) | currency: 'EUR' }}</td>
                        <td>
                            <div class="flex gap-2 justify-content-end" [class.rowGroup]="transactionLine.isGroup">
                                <!--<p-button *ngIf="allowDelete && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" (click)="duplicateLine(transactionLine)" [rounded]="true" [text]="false" severity="danger"><i class="pi pi-clone"></i></p-button>-->
                                <p-button *ngIf="allowDelete && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" (click)="deleteLine(transactionLine)" [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button *ngIf="allowWrite && transactionLine.jobId == null && (transaction.netSuiteId == null || (transaction.netSuiteId != null && allowChangeEvenNetSuiteId))" (click)="editTransactionLine(transactionLine.isGroup, transactionLine, null)" [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer" *ngIf="transactionType.enablePrice">
                    <tr *ngFor="let ratelineg of groupByRatelines">
                        <td [attr.colspan]="(transactionType.enableRate?(this.type=='incoming_invoice'?7:(this.type=='outgoing_budget'?6:8)):5)" style="text-align: right;">
                            {{ratelineg.description}}
                        </td>
                        <td style="text-align: right;">
                            {{ratelineg.subtotal | currency: 'EUR'}}
                        </td>
                        <td style="text-align: right;" *ngIf="transactionType.enableTax && showTax">
                            {{ratelineg.taxAmount | currency: 'EUR'}}
                        </td>
                        <td style="text-align: right;" *ngIf="showTax">
                            {{ratelineg.total | currency: 'EUR'}}
                        </td>
                        <td> &nbsp;</td>
                    </tr>
                    <tr>
                        <td [attr.colspan]="(transactionType.enableRate?(this.type=='incoming_invoice'?7:(this.type=='purchase_order'?7:(this.type=='outgoing_budget'?6:8))):5)" style="text-align: right;"></td>
                        <!--lo oculto porque no existe el incrementAmount en la transacción y sino se descuadra
                        <td *ngIf="transactionType.enableDiscount" style="text-align: right;">
                            {{ transaction.discountAmount | currency: 'EUR' }}
                        </td>-->
                        <td style="text-align: right;">{{transaction.isReturn?'-':''}}{{ transaction.subtotal | currency: 'EUR' }}</td>
                        
                        <td *ngIf="transactionType.enableTax && showTax" style="text-align: right;">
                            {{transaction.isReturn?'-':''}}{{ transaction.taxAmount | currency: 'EUR' }}
                        </td>
                        <td  *ngIf="transactionType.enableTax && transactionType.enablePrice && showTax" style="text-align: right;">
                            {{transaction.isReturn?'-':''}}{{ transaction.total | currency: 'EUR' }}
                        </td>
                        <td> &nbsp;</td>
                    </tr>
                    <tr *ngIf="transaction.advancedAmmount > 0">                      
                        <td [attr.colspan]="visibleColumnsCount" style="text-align: right;">Anticipo:</td>
                        <td style="text-align: right;">{{ transaction.advancedAmmount | currency: 'EUR' }}</td>
                        <td></td>
                    </tr>
                    <tr *ngIf="transaction.advancedAmmount > 0">                      
                        <td [attr.colspan]="visibleColumnsCount" style="text-align: right;">Total:</td>
                        <td style="text-align: right;">
                            {{ (transaction.total - transaction.advancedAmmount) | currency: 'EUR' }}
                        </td>
                        <td ></td>
                    </tr>
                </ng-template>
                <!--<ng-template pTemplate="footer" *ngIf="transactionType.enablePrice">                    
                    <tr>                      
                      <td [attr.colspan]="visibleColumnsCount" style="text-align: right;">Subtotal:</td>
                      <td style="text-align: right;">{{transaction.isReturn?'-':''}}{{ transaction.subtotal | currency: 'EUR' }}</td>
                      <td></td>
                    </tr>
                    <tr *ngIf="transaction.discountAmount > 0">                      
                        <td [attr.colspan]="visibleColumnsCount" style="text-align: right;">Descuentos:</td>
                        <td style="text-align: right;">{{ transaction.discountAmount | currency: 'EUR' }}</td>
                        <td></td>
                    </tr>
                    <tr *ngIf="transaction.workRetention > 0">                      
                        <td [attr.colspan]="visibleColumnsCount" style="text-align: right;">Retención de obra:</td>
                        <td style="text-align: right;">{{ transaction.workRetention | currency: 'EUR' }}</td>
                        <td></td>
                    </tr>
                    <tr>                      
                        <td [attr.colspan]="visibleColumnsCount" style="text-align: right;" *ngIf="transactionType.enableTax">Impuestos:</td>
                        <td style="text-align: right;" *ngIf="transactionType.enableTax">{{transaction.isReturn?'-':''}}{{ transaction.taxAmount | currency: 'EUR' }}</td>
                        <td></td>
                    </tr>
                    <tr *ngIf="transactionType.enableTax && transactionType.enablePrice">                      
                      <td [attr.colspan]="visibleColumnsCount" style="text-align: right;">Total:</td>
                      <td style="text-align: right;">{{transaction.isReturn?'-':''}}{{ transaction.total | currency: 'EUR' }}</td>
                      <td></td>
                    </tr>
                    <tr *ngIf="transaction.advancedAmmount > 0">                      
                        <td [attr.colspan]="visibleColumnsCount" style="text-align: right;">Anticipo:</td>
                        <td style="text-align: right;">{{ transaction.advancedAmmount | currency: 'EUR' }}</td>
                        <td></td>
                    </tr>
                    <tr *ngIf="transaction.advancedAmmount > 0">                      
                        <td [attr.colspan]="visibleColumnsCount" style="text-align: right;">Total:</td>
                        <td style="text-align: right;">
                            {{ (transaction.total - transaction.advancedAmmount) | currency: 'EUR' }}
                        </td>
                        <td></td>
                    </tr>
                  </ng-template>-->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td style="text-align: center;" colspan="9">
                            No se han encontrado líneas.
                        </td>
                    </tr>
                </ng-template>
            </p-table>
    </p-card>

    <p-card class="tx-events-card" *ngIf="allowShowAdditionalInfo">
        <p-accordion [multiple]="false">
            <p-accordionTab>
            <ng-template pTemplate="header">
                <span>Información adicional del documento</span>
            </ng-template>
            <div class="col-12 input-field" *ngIf="transactionType.enablePaymentConditionNotes">
                <label for="paymentConditionsNotes">Texto condiciones de pago</label>
                <textarea formControlName="paymentConditionsNotes" pInputTextarea rows="5" d-form-field-error></textarea>
            </div>
            <div class="col-12 input-field" *ngIf="transactionType.enableValidityDocNotes">
                <label for="validityDocNotes">Texto validez del documento</label>
                <textarea formControlName="validityDocNotes" pInputTextarea rows="5" d-form-field-error></textarea>
            </div>
            </p-accordionTab>
        </p-accordion>
    </p-card>

    <p-card class="tx-events-card" *ngIf="transactionLogs.length > 0">
        <p-accordion [multiple]="false">
            <p-accordionTab>
            <ng-template pTemplate="header">
                <span>Eventos de la transacción</span>
                <span class="tx-events__count">{{ transactionLogs.length }}</span>
            </ng-template>

            <ol class="tx-timeline">
                <li class="tx-timeline__item" *ngFor="let log of transactionLogs">
                <div class="tx-timeline__meta">
                    <span class="tx-timeline__time">
                    {{log.date | date: 'dd/MM/yyyy'}}<br>{{log.date | date: 'HH:mm'}}
                    </span>
                    <span class="tx-timeline__user">
                        <i class="pi pi-user" style="font-size: 8px"></i>
                        {{log.createdByUser?.name}}
                    </span>
                </div>
                <div class="tx-timeline__detail">
                    <div [innerHtml]="log.notes" style="white-space: pre-wrap;"></div>
                </div>
                </li>
            </ol>
            </p-accordionTab>
        </p-accordion>
        </p-card>
    
</form>

    <p-card  *ngIf="transaction.id && (transactionType.code == 'company_outgoing_budget' ||transactionType.code == 'outgoing_budget'||transactionType.code == 'affected_outgoing_budget')" styleClass="mt-4">
       <ng-template pTemplate="header">
            
                <span class="flex items-center gap-2 w-full align-items-center">
                    <span class="font-bold whitespace-nowrap">Presupuestos de operario</span>
                    <div class="flex-grow-1"></div>
                    <span *ngIf="caseTransactionsRelateResume!=0" class="p-tag flex gap-2 align-items-center" 
                        [class.p-tag-danger]="caseTransactionsRelateResume<0" [class.p-tag-success]="caseTransactionsRelateResume>0"
                    >
                        <span class="p-tag-label">{{caseTransactionsRelateResume | number:'1.0-2'}} €</span>
                    </span>
                    <span *ngIf="caseTransactionsRelateResumePercent!=0" class="p-tag flex gap-2 align-items-center" 
                        [class.p-tag-danger]="caseTransactionsRelateResumePercent<0" [class.p-tag-success]="caseTransactionsRelateResumePercent>0"
                    >
                        <span class="p-tag-label">{{caseTransactionsRelateResumePercent | number:'1.0-2'}} %</span>
                    </span>
                </span>
        </ng-template>
        <div class="col-12 input-field" *ngIf="relatedTransactions.length == 0">
            No se encuentras presupuestos de operarios disponibles para esta compañía.
        </div>
        <div class="col-12 input-field" *ngIf="relatedTransactions.length > 0">
            <label for="isBillable">Seleccione presupuesto</label>
            <p-dropdown [options]="relatedTransactions" [(ngModel)]="selectedBudget" showClear
                appendTo="body" [filter]="true" filterBy="code" placeholder="Selecciona un presupuesto" (onChange)="loadRelatedTransactionInfo($event)"
                d-form-field-error>
                <ng-template pTemplate="selectedItem" let-item > 
                    <div class="flex flex-column" *ngIf="item">
                        {{item.code}} - {{item.date | date:'dd/MM/yyyy'}} - {{item.transactionState?.name}}
                    </div>
                </ng-template>
                <ng-template let-transactionRelated pTemplate="item">
                    <div class="flex flex-column">
                        {{transactionRelated.code}} - {{transactionRelated.date | date:'dd/MM/yyyy'}} - {{transactionRelated.transactionState?.name}}
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-12 input-field"> {{transactionFrom?.description}}</div>
        <p-table *ngIf="transactionFrom != null && transactionFrom.transactionLines != null" styleClass="m-1 mt-4" #grid [value]="transactionFrom.transactionLines" [loading]="loadingTransactionLines"
                [totalRecords]="totalTransactionLines" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [scrollable]="true" scrollHeight="flex">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th>Baremo</th>                        
                        <th>Descripción</th>                        
                        <th style="text-align: right;">Cantidad</th>                        
                        <th style="text-align: right;">Precio unidad</th>      
                        <th style="text-align: right;">Impuestos</th>                        
                        <th  style="text-align: right;">Importe</th>                        
                    </tr>
                </ng-template> 
                <ng-template pTemplate="body" let-transactionLine let-i="rowIndex" let-columns="columns" let-index="rowIndex">
                    <tr>
                        <td >{{transactionLine.rateLine?.code}} {{transactionLine.rateLine?.description}}</td>
                        <td>{{transactionLine.description}}</td>
                        <td style="text-align: right;">{{transactionLine.quantity}}</td>
                        <td style="text-align: right;">{{transactionLine.price}}</td>
                        <td style="text-align: right;">{{'('+(transactionLine.taxPercent!=null?transactionLine.taxPercent:0)+'%) '}}{{transactionLine.taxAmount | currency: 'EUR' }}</td>
                        <td style="text-align: right;">{{transactionLine.subtotal | currency: 'EUR' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">                    
                    <tr >                      
                      <td [attr.colspan]="5" style="text-align: right;">Subtotal:</td>
                      <td style="text-align: right;">{{ transactionFrom.subtotal | currency: 'EUR' }}</td>
                    </tr>
                    <!--<tr *ngFor="let taxRate of (totalTax() | keyvalue)" >                      
                        <td [attr.colspan]="5" style="text-align: right;">Impuesto ({{ taxRate.key }}%):</td>
                        <td style="text-align: right;">{{ taxRate.value | currency: 'EUR' }}</td>
                        <td></td>
                    </tr>-->
                    <tr >                      
                      <td [attr.colspan]="5" style="text-align: right;">Total:</td>
                      <td style="text-align: right;">{{ transactionFrom.total | currency: 'EUR' }}</td>
                    </tr>
                  </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td style="text-align: center;" colspan="9">
                            No se han encontrado líneas.
                        </td>
                    </tr>
                </ng-template>
            </p-table>


    </p-card>

<div *ngIf="transaction.id && transactionType.enablePhotos " class="mt-4">
    <p-card header="Incluir Fotografías">
        <div class="grid">
            <p-card *ngIf="caseFilesWithoutService.length > 0" styleClass=" p-card-content-no-padding enabledPhotosColor">
                <ng-template pTemplate="header">
                    <div class="p-card-title flex gap-2">
                        Sin sevicio
                    <div class="flex-grow-1"></div>
                    <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox (onChange)="selectAll($event, null)" [binary]="true"  />Seleccionar todos</label>
                    </div>
                </ng-template>
                <div class="grid">
                    <div *ngFor="let file of caseFilesWithoutService; let  i = index" >
                        <div *ngIf="fileIsAnImage(file.file)"
                            style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                            <img [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'" alt="{{file.file?.fileName}}" width="150"
                                        
                            (mouseenter)="hoveredImage = file"
                            (mouseleave)="hoveredImage = null" />
                            <div class="flex justify-content-between align-items-center mt-1">
                                <span>{{file.index}}.&nbsp;{{file.file?.caseFileCategory?.name}}</span>
                                <p-checkbox  (onChange)="selectFile(file.fileId, 'empty')" [(ngModel)]="transactionFilesIdChecked['empty']" [value]="file.fileId"  />
                            </div>
                        </div>
                    </div>
                </div>
            </p-card>
            <div class="hovered-image" *ngIf="hoveredImage!=null">
                <img [src]="imagesUrl + hoveredImage.fileId + '/show'" style="max-width: 600px; max-height: 600px;" />
            </div>
            <div *ngFor="let service of caseFilesServices" class="w-full" >
                <p-card styleClass="mt-2 p-card-content-no-padding enabledPhotosColor">
                    <ng-template pTemplate="header">
                        <div class="p-card-title flex gap-2">
                            {{service.name}} 
                           
                            <div class="flex-grow-1"></div>
                            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox (onChange)="selectAll($event, service.id)"  [binary]="true"   />Seleccionar todos</label>                
                        </div>
                        <div *ngIf="service.pendingTasksDescription"><b>Trabajos pendientes:</b>&nbsp;{{service.pendingTasksDescription}}</div>
                        <div *ngIf="service.realizedTasksDescription"><b>Trabajos realizados:</b>&nbsp;{{service.realizedTasksDescription}}</div>
                    </ng-template>
                    <div class="grid">
                        <div *ngFor="let file of filesByService(service.id);let  i = index">                           

                            <div *ngIf="fileIsAnImage(file.file)" 
                                style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                                <img 
                                    [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'"
                                     width="150"                                       
                                    (mouseenter)="hoveredImage = file"
                                    (mouseleave)="hoveredImage = null" />
                                <div class="flex justify-content-between align-items-center mt-1">
                                    <span>{{file.index}}.&nbsp;{{file.caseFileCategory?.name}}</span>
                                    <p-checkbox  (onChange)="selectFile(file.fileId, service.id)" [(ngModel)]="transactionFilesIdChecked[service.id]"  [value]="file.fileId" />
                                </div>
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </p-card>
</div>

<div *ngIf="transaction.id && transactionType.enableFiles " class="mt-4">
    <p-card header="Archivos adjuntos" >
        <div class="tx-attachments">
            <a class="tx-attachment" *ngFor="let file of transactionFiles" [title]="file.file.fileName"
                [href]="imagesUrl + file.fileId + '/download'" target="_blank">
                <i class="pi pi-file tx-attachment__icon"></i>
                <span class="tx-attachment__info">
                    <span class="tx-attachment__name">{{file.file.fileName}}</span>
                    <span class="tx-attachment__date">{{file.file.createdAt | date: 'dd/MM/yyyy HH:mm'}}</span>
                </span>
                <i class="pi pi-download tx-attachment__action"></i>
            </a>
        </div>
    </p-card>
</div>

<!--<p-overlayPanel #op [appendTo]="'body'" styleClass="image-overlay-panel-transactions">
    <img [src]="imagesUrl + opFile?.fileId + '/show'" style="max-height: 600px; max-width: 500px; border-radius: 10px;" />
</p-overlayPanel>-->

<p-dialog header="Motivo de estado" [(visible)]="showStateNotes" appendTo="body" [modal]="true" [closable]="true" [style]="{width: '500px'}">
    <div class="col-12 input-field">
        <label for="notes">Notas</label>
        <textarea [(ngModel)]="notes" pInputTextarea rows="5" d-form-field-error></textarea>
    </div>
    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="showStateNotes=false"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="saveStateNotes(notes)"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Abono" [(visible)]="displayPaymentModal" [modal]="true" [closable]="false"
    [style]="{width: '500px'}">
    <div class="grid">
        <div class="col-6 input-field">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="payment.date" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error
                appendTo="body"></p-calendar>
        </div>
        <div class="col-6 input-field">
            <label for="code">Tipo de abono</label>
            <p-dropdown [(ngModel)]="payment.type" [options]="typesPayment"
                optionLabel="name" optionValue="id" appendTo="body" filterBy="name"
                placeholder="Seleccione opción"  d-form-field-error></p-dropdown>                            
        </div> 

        <div class="col-6 input-field" *ngIf="payment.type=='partial'">
            <label for="price">Precio</label>
            <input [(ngModel)]="payment.price" pInputText type="number" d-form-field-error (input)="calculatePrices()">
        </div>   
                     
        <div class="col-6 input-field" *ngIf="payment.type=='partial'">
            <label for="code">Impuestos(%)</label>
            <p-dropdown [(ngModel)]="payment.taxPercent" [options]="taxes"
                optionLabel="displayName" optionValue="percent" appendTo="body" filterBy="name"
                placeholder="Seleccione opción" (onChange)="calculatePrices()" d-form-field-error></p-dropdown>                            
            <label class="mt-2">
                {{ payment.taxAmount | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>
        <div class="col-6 input-field">
            <label for="total">Importe</label>
            <input pInputText type="text" value="{{ payment.subtotal | currency:'EUR':'symbol':'1.2-2' }}" disabled>
        </div>
        <div class="col-12 input-field">
            <label for="description">Notas</label>
            <textarea pInputTextarea [(ngModel)]="payment.notes" style="field-sizing: content;"
                d-form-field-error rows="3"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="displayPaymentModal=false"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="savePayment()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Añadir plantilla baremo" [(visible)]="showSRateTemplates" appendTo="body" [modal]="true" [closable]="true" [style]="{width: '500px'}">
    <div class="col-12 input-field">
        <label for="notes">Plantilla baremo</label>
        <p-dropdown [(ngModel)]="rateTemplateId" [options]="rateTemplates"
                optionLabel="name" optionValue="id" appendTo="body" filterBy="name"
                placeholder="Seleccione opción" d-form-field-error></p-dropdown>
    </div>
    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="showSRateTemplates=false"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="saveRateTemplates(rateTemplateId)"></button>
    </ng-template>
</p-dialog>
<p-confirmDialog *ngIf="!isDialog" />